import { forwardRef, ReactNode } from "react";
import { cx } from "class-variance-authority";
import { useFormGroup } from "../FormGroup";
import { FieldError } from "react-hook-form";
import { Nil } from "cy-util";

export interface FormErrorProps {
  className?: string;
  children?: ReactNode;
  errorMessages?: Record<string, string>;
  "data-testid"?: string;
}

/**
 *
 */
export const FormError = forwardRef<any, FormErrorProps>(
  (
    { className, children, errorMessages, "data-testid": dataTestId, ...rest },
    ref,
  ) => {
    const { controller } = useFormGroup() || {};
    const fieldState = controller?.fieldState;
    const error = fieldState?.error;
    const classes = cx(className, "text-red-500", "text-sm mt-1");
    const showError = !!error || (!controller && !!children);

    // Auto-generate data-testid from field name if not provided
    const generateTestId = () => {
      if (dataTestId) return dataTestId;
      if (controller?.field.name) {
        return `form-error-${controller.field.name.replace(/\./g, "-")}`;
      }
      return "form-error";
    };

    const testId = generateTestId();

    return (
      <div ref={ref} {...rest} className={classes} data-testid={testId}>
        {showError
          ? children ||
            errorMessages?.[error!.type] ||
            error!.message ||
            "Invalid Value"
          : ""}
      </div>
    );
  },
);
FormError.displayName = "FormError";

export function formErrorMessage(
  error: FieldError | Nil,
  messages: Record<string, string> = {},
  defaultMessage = "",
) {
  if (!error) return null;
  return (
    error.message || messages[error.type] || defaultMessage || "Invalid Value"
  );
}
